import { AppState } from 'src/app/app.state';
import { EnvironmentState } from './environment.state';
import { createSelector } from '@ngrx/store';

/**
 * Selects the environment state
 * @param state The application state
 * @returns The environment state
 */
export const selectEnvironment = (state: AppState): EnvironmentState => state.environment;

/**
 * Selects the gateway url from the environment state.
 * @returns The gateway URL
 */
export const selectGatewayUrl = createSelector(
	selectEnvironment,
	(state: EnvironmentState): string => state.gatewayUrl
);

/**
 * Selects the environment name from the environment state.
 * @returns The gateway URL
 */
export const selectEnvironmentName = createSelector(
	selectEnvironment,
	(state: EnvironmentState): string => state.environmentName
);
